import { Spin } from 'antd'

export default props => {
  return (
    <div style={props.style}>
      <Spin />

      <style jsx>{`
        div {
          text-align: center;
          background: rgba(0, 0, 0, 0.05);
          border-radius: 4px;
          padding: 30px 50px;
        }
      `}
      </style>
    </div>
  )
}
